module.exports = __webpack_public_path__ + "img/20190708165909803.4d5da8a7.png";